import React from 'react'
import { withTranslation } from 'react-i18next'
import { createUseStyles } from 'react-jss'

const useStyles = createUseStyles({
  root: {
    padding: '8px 12px',
    border: 'solid 2px #0046AD',
    textAlign: 'left',
    '& h4' : {
      fontWeight: 'bold'
    },
    '& p' : {
      marginBottom: '10px'
    },
    '& button': {
      backgroundColor: '#0046AD',
      border: 'solid 2px #0046AD',
      borderRadius: '2px',
      padding: '8px 12px',
      color: '#FFF',
      fontSize: '16px',
      textAlign: 'left'
    }
  },
})

const AppCard = (props) => {
  const { apps } = props
  const classes = useStyles()

  const handleClick = (appEnv) => (e) => {
    window.location = appEnv[process.env.REACT_APP_ENV].login
  }

  return apps.map((app, i) => (

    <div className={classes.root}>
      <h4>{app.name}</h4>
      <p>{app.description}</p>
      <button
        key={i}
        type="button"
        aria-label={`Launch ${app.name}`}
        onClick={handleClick(app.env)}
      >Continue
    </button>
    </div>
  ))
}

export default withTranslation()(AppCard)